import { render, staticRenderFns } from "./showBigAll.vue?vue&type=template&id=20874ef7&scoped=true"
import script from "./showBigAll.vue?vue&type=script&lang=js"
export * from "./showBigAll.vue?vue&type=script&lang=js"
import style0 from "./showBigAll.vue?vue&type=style&index=0&id=20874ef7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20874ef7",
  null
  
)

export default component.exports